
/**
 * @class DownloadTransactionsFilter
 * @classdesc Class definition for controlling transaction filtering, the
 * transactions of which will be downloaded in a format like a csv.
 * @property {STRING} _date - The transaction maximum date range id to filter by.
 * @property {STRING} _type - The transaction type id to filter by.
 * @property {STRING} _exportFormat - The transaction export format to use.
 * @property {ARRAY} _selectedAccountIDs - An array of selected account ids, 
 * whose transactions we will get to download. By default, it is undefined.
 */
export default class DownloadTransactionsFilter {
    _date;
    _type;
    _exportFormat;
    _selectedAccountIDs;

    constructor(record) {
        this.date = record.date;
        this.type = record.type;
        this.exportFormat = record.exportFormat;
        this.selectedAccountIDs = record.selectedAccountIDs;
    }

    /**
     * @name date
     * @instance
     * @property set {STRING} - sets the date
     * @memberof DownloadTransactionsFilter
     */
    set date(value) { this._date = value; }

    /**
     * @name type
     * @instance
     * @property set {STRING} - sets the type
     * @memberof DownloadTransactionsFilter
     */
    set type(value) { this._type = value; }

    /**
     * @name exportFormat
     * @instance
     * @property set {STRING} - sets the exportFormat
     * @memberof DownloadTransactionsFilter
     */
    set exportFormat(value) { this._exportFormat = value; }

    /**
     * @name selectedAccountIDs
     * @instance
     * @property set {STRING} - sets the selectedAccountIDs
     * @memberof DownloadTransactionsFilter
     */
    set selectedAccountIDs(value) { this._selectedAccountIDs = value; }

    /**
     * @name date
     * @instance
     * @property get {STRING} - returns the date
     * @memberof DownloadTransactionsFilter
     */
    get date() { return this._date; }

    /**
     * @name type
     * @instance
     * @property get {STRING} - returns the type
     * @memberof DownloadTransactionsFilter
     */
    get type() { return this._type; }

    /**
     * @name exportFormat
     * @instance
     * @property get {STRING} - returns the exportFormat
     * @memberof DownloadTransactionsFilter
     */
    get exportFormat() { return this._exportFormat; }

    /**
     * @name selectedAccountIDs
     * @instance
     * @property get {ARRAY} - returns the selectedAccountIDs
     * @memberof DownloadTransactionsFilter
     */
    get selectedAccountIDs() { return this._selectedAccountIDs; }

    /**
     * @name filters
     * @instance
     * @property get {OBJECT} - returns the set filter properties
     * @memberof DownloadTransactionsFilter
     */
    // TO DO: This code is from class "TransactionSearch" and similar support may be needed
    // once we have data to filter.
    /*get filters() {
        return Object.getOwnPropertyNames(this).reduce((result, name) => {
            const key = name.slice(1);
            const value = this[key];

            if(value !== undefined && value !== "" && (key !== "ranges" && key !== "types")){
                result[key] = value;
            }

            return result;
        }, {});
    }*/
    
    /**
     * @name record
     * @instance
     * @property get {OBJECT} - returns the set values
     * @memberof DownloadTransactionsFilter
     */
    get record() {
        return {
            date: this.date,
            type: this.type,
            exportFormat: this.exportFormat,
            selectedAccountIDs: this.selectedAccountIDs
        };
    }

    // TO DO: This code is from class "TransactionSearch" and similar support may be needed
    // once we have data to filter.
    /*checkValue(transaction, key) {
        switch(key) {
            case "date":
                return transaction.date.isAfter(BCMSDate.init().offset(this.date));
    
            case "description":
                return transaction.description.toLowerCase().indexOf(this.description.toLowerCase()) > -1;
    
            case "type":
                return this.type === "all" ? true : transaction.filterType === this.type;
    
            case "amount":
                const amount = parseFloat(transaction.amount.amount);
                return parseFloat(this.amount.amount) === (amount < 0 ? -amount : amount);
    
            case "check":
                const desc = transaction.description;
                return desc.toLowerCase().indexOf("check") > -1 && desc.indexOf(this.check) > -1;
    
            default:
                return true;
        }
    }*/

    // TO DO: This code is from class "TransactionSearch" and similar support may be needed
    // once we have data to filter.
    /*filter() {
        return Transaction.initByAccount(this.accountID)
            .filter(transaction => {
                return Object.keys(this.filters).reduce((result, key) => {
                    if(!this.checkValue(transaction, key)) {
                        result = false;
                    }

                    return result;
                }, true);
            }, []);
    }*/

    reset() {
        const vals = { 
            date: "30",
            type: "all",
            exportFormat: "csv",
            selectedAccountIDs: undefined
        };
        return DownloadTransactionsFilter.init(vals);
    }
    
    static init(record) {
        const vals = { 
            date: "30",
            type: "all",
            exportFormat: "csv",
            selectedAccountIDs: undefined,
            ...record ?? {} 
        }
        return new DownloadTransactionsFilter(vals);
    }
}